import { __constants } from "../constants"

export const sendCustomNotificationController = async (data) => {
  try {
    const token = localStorage.getItem(__constants.authToken)
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/notification/send-custom-notification`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()
    return { data: result }
  } catch (error) {
    console.error("Error sending custom notification:", error)
    return {
      data: {
        status: 500,
        message: "Failed to send notification",
      },
    }
  }
}

export const scheduleNotificationController = async (data) => {
  try {
    const token = localStorage.getItem(__constants.authToken)
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/notification/schedule-notification`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()
    return { data: result }
  } catch (error) {
    console.error("Error scheduling notification:", error)
    return {
      data: {
        status: 500,
        message: "Failed to schedule notification",
      },
    }
  }
}

export const getScheduledNotificationsController = async (filters = {}) => {
  try {
    const token = localStorage.getItem(__constants.authToken)
    const queryParams = new URLSearchParams()

    if (filters.status) queryParams.append("status", filters.status)
    if (filters.fromDate) queryParams.append("fromDate", filters.fromDate)
    if (filters.toDate) queryParams.append("toDate", filters.toDate)

    const url = `${process.env.REACT_APP_SERVER_URL}/v1/notification/schedule-notifications${queryParams.toString() ? "?" + queryParams.toString() : ""}`

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    const result = await response.json()
    return { data: result }
  } catch (error) {
    console.error("Error fetching scheduled notifications:", error)
    return {
      data: {
        status: 500,
        message: "Failed to fetch scheduled notifications",
        data: [],
      },
    }
  }
}

export const updateScheduledNotificationController = async (id, data) => {
  try {
    const token = localStorage.getItem(__constants.authToken)
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/notification/schedule/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    })

    const result = await response.json()
    return { data: result }
  } catch (error) {
    console.error("Error updating scheduled notification:", error)
    return {
      data: {
        status: 500,
        message: "Failed to update scheduled notification",
      },
    }
  }
}

export const deleteScheduledNotificationController = async (id) => {
  try {
    const token = localStorage.getItem(__constants.authToken)
    const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/v1/notification/schedule/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    })

    const result = await response.json()
    return { data: result }
  } catch (error) {
    console.error("Error deleting scheduled notification:", error)
    return {
      data: {
        status: 500,
        message: "Failed to delete scheduled notification",
      },
    }
  }
}
